import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "@shared/auth/auth.service";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessFollowUpSiteVisitViewModel, IBusinessPostRemediationPlanSiteVisitViewModel, IBusinessSiteVisitViewModel } from "app/models/complaints/siteVisit";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { SiteVisitService } from "app/services/complaint/siteVisit.service";
import { PostRemediationEditComponent } from "../postRemediationEdit/postRemediationEdit.component";
import { Subscription } from "rxjs";

@Component({
  selector: 'shared-postRemediationVisit',
  templateUrl: './postRemediationVisit.component.html',
  styleUrls: ['./postRemediationVisit.component.scss']
})

export class PostRemediationVisitComponent implements OnInit {

  @Input() parentPanel: number = 0;

  visitSubscription: Subscription;
  complaintId: number = 0;
  followupLength: number = 0;
  businessId: number = 0;
  isAdmin: boolean = false;
  // siteVisit: number = 0;
  postVisitList: IBusinessPostRemediationPlanSiteVisitViewModel[] = [];
  siteVisits: IBusinessSiteVisitViewModel = {} as IBusinessSiteVisitViewModel;
  followupFlag: boolean = false;
  addFlag: boolean = false;
  initialSiteLength: number = 0;


  displayedColumns: string[] = ['action', 'complaintId', 'postRemediationDate', 
    'postRemediationConducted', 'postRemediationResult', 'comments'];
  dataSource = new MatTableDataSource<IBusinessPostRemediationPlanSiteVisitViewModel>(this.postVisitList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    private siteVisitService: SiteVisitService,
    private complaintService: ComplaintService,
    private sharedService: SharedService,
    private authService: AuthService,
    private modalService: MatDialog
  ) {

  }

  ngOnInit(): void {
    this.isAdmin = this.authService.isAdmin;

    this.visitSubscription = this.siteVisitService.updateSiteVistEvent.subscribe((data: number) => {
      this.postVisitList = this.siteVisitService.siteVisit.postRemediationPlanSiteVisits;
      this.siteVisits = this.siteVisitService.siteVisit;
      this.dataSource.data = this.postVisitList;
      this.complaintId = this.complaintService.complaintId;
      this.followupLength = this.siteVisitService.siteVisit.followupSiteVisits.length;
      this.initialSiteLength = this.siteVisitService.siteVisit.initialSiteVisits.length;
      this.addFlag = this.complaintId > 0  && this.siteVisits.canAddPostRemediationSiteVisit;
    });
  }

  ngOnDestroy() {
    this.visitSubscription.unsubscribe();
  }

  addPostRemediationSiteVisit() {

    let postVisit: IBusinessPostRemediationPlanSiteVisitViewModel = {
      id: 0,
      complaintId: this.complaintId,
      followupVisitId: 0,
      postRemediationConducted: null,
      postRemediationDate: '',
      postRemediationResult: null,
      comments: '',
      allowEditing: true,
    }
    this.editPostRemediationVisit(postVisit);

  }

  removePostRemediationSiteVisit(visit: IBusinessPostRemediationPlanSiteVisitViewModel) {
    this.sharedService.openConfirm("Are you sure you want to delete this visit?");

    this.sharedService.confirmed().subscribe(
      confirmed => {
        if (confirmed) {
          this.siteVisitService.deleteSiteVisits(visit.id, this.siteVisitService.statusPostRemediation).subscribe({
            next: response => {
              this.siteVisitService.getSiteVisitData(this.siteVisitService.siteVisit.businessId);
              this.sharedService.toastr.success("Site Visit deleted.");
            },
            error: e => {
              this.sharedService.toastr.error("Could not delete site visit data.");
            },
          });
        }
      }
    );
  }

  editPostRemediationVisit(visit: IBusinessPostRemediationPlanSiteVisitViewModel) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = true;
    config.minWidth = 600;
    config.maxWidth = 600;
    config.maxHeight = 800;
    config.data = {
      siteVisit: visit,
      followupVisitItems: this.postVisitList
    };
    const dialogRef = this.modalService.open(PostRemediationEditComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.siteVisitService.getSiteVisitData(this.siteVisitService.siteVisit.businessId);
        }
      },
      error => this.sharedService.toastr.error("Error"),
      () => { }
    );
  }

  gotoComplaint(complaint: IBusinessFollowUpSiteVisitViewModel) {
    this.complaintService.complaintId = complaint.complaintId;
    this.complaintService.complaintTab = 4;
    this.complaintService.complaintVisitTab = 2;
    this.sharedService.doRedirect('complaint/complaint/' + complaint.complaintId);
  }

}